import { SocketGoogleCalendarEvent } from '@modules/EvaluationModule/interfaces/SocketGoogleCalendarEvent';
import { createAction } from '@reduxjs/toolkit';

export const updateGoogleCalendarEvalAction = createAction<SocketGoogleCalendarEvent>('updateGoogleCalendarEvalAction');
